module.exports = __webpack_public_path__ + "d34cc54125f17681328dc2a1eec31284.svg";